import AccurateWeather from "./HistWeatherGreenChart";

export default AccurateWeather;